import script from "./OrganizationCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationCreateForm.vue?vue&type=style&index=0&id=5fe34642&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe34642"]])

export default __exports__